import { render, staticRenderFns } from "./BalanceResumenTab.vue?vue&type=template&id=f2234ae6&scoped=true"
import script from "./BalanceResumenTab.vue?vue&type=script&lang=js"
export * from "./BalanceResumenTab.vue?vue&type=script&lang=js"
import style0 from "./BalanceResumenTab.vue?vue&type=style&index=0&id=f2234ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2234ae6",
  null
  
)

export default component.exports